import { SignIn } from "@clerk/clerk-react";
import { Link } from "react-router-dom";
import { RoutePath } from "@/routePaths";
import { AuthHeroSection } from "@/components/auth/AuthHeroSection";
import { KiwiPatternBackground } from "@/components/auth/KiwiPatternBackground";

export function SignInPage() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background overflow-hidden">
      <KiwiPatternBackground />

      <div className="relative z-10 w-full max-w-md px-6">
        <AuthHeroSection />

        <SignIn routing="hash" signUpUrl={RoutePath.SignUp} />

        <p className="mt-6 text-center text-sm text-muted-foreground">
          Don&apos;t have an account?{" "}
          <Link
            to={RoutePath.SignUp}
            className="text-primary font-medium hover:underline"
          >
            Sign up
          </Link>
        </p>
      </div>
    </div>
  );
}
